import { Routes } from '@angular/router'
import { RoutesEnum } from '@ui-core/enums/routes.enum'
import { canDeactivateGuard } from '@ui-core/guards/alert-unsaved-changes.guard'
import { AuthGuard } from '@ui-core/guards/auth.guard'

export const jobsRoutes: Routes = [
    {
        path: RoutesEnum.INVENTORY_OPTIMIZATION_JOBS,
        loadComponent: () => import('./jobs').then((m) => m.Jobs),
        canActivate: [AuthGuard]
    },
    {
        path: RoutesEnum.INVENTORY_OPTIMIZATION_JOB + '/new',
        loadComponent: () => import('./job').then((m) => m.Job),
        canActivate: [AuthGuard],
        canDeactivate: [canDeactivateGuard]
    },
    {
        path: RoutesEnum.INVENTORY_OPTIMIZATION_JOB + '/:id',
        loadComponent: () => import('./job').then((m) => m.Job),
        canActivate: [AuthGuard],
        canDeactivate: [canDeactivateGuard]
    }
]
